export default __webpack_public_path__ + "static/media/aventurier.2bee3191.mp3";